
export enum Length{
	CENTIMETER = "cm",
	INCH = "in"
}
export enum Mass {
	KILOGRAM = "kg",
	POUND = "lb"
}